import { FC, PropsWithChildren } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

import MaintenancePage from './MaintenancePage';
import MaintenanceBanner from './MaintenanceBanner';

import { MaintenanceFlag, MaintenanceMode } from '../types';

const MaintenanceProvider: FC<PropsWithChildren> = ({ children }) => {
    const { showSiteUnderMaintenance } = useFlags();

    const maintenanceFlag: MaintenanceFlag =
        showSiteUnderMaintenance && typeof showSiteUnderMaintenance === 'object'
            ? showSiteUnderMaintenance
            : null;

    if (!maintenanceFlag || !maintenanceFlag?.mode) {
        return children;
    }

    return (
        <>
            {maintenanceFlag?.mode === MaintenanceMode.BANNER && (
                <>
                    <MaintenanceBanner flag={maintenanceFlag} />
                    {children}
                </>
            )}
            {maintenanceFlag?.mode === MaintenanceMode.PAGE && (
                <MaintenancePage flag={maintenanceFlag} />
            )}
        </>
    );
};

export default MaintenanceProvider;
